// Modules
import React, { useCallback, useContext, useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

// Pages
// import Account from 'pages/account/Account'
import Error from 'pages/error/Error'
import Hub from 'pages/hub/Hub'
import PasswordChange from 'pages/password-change/PasswordChange'
import TermsOfService from 'pages/terms-of-service/TermsOfService'
import TwoFactorAuthentication from 'pages/two-factor-authentication/TwoFactorAuthentication'

// Hooks
import useAccount from 'hooks/account/useAccount'
import useRedirect from 'hooks/external/useRedirect'
import useToken from 'hooks/authentication/useToken'

// Context
import Data from 'context/Data'

// Helpers
import { checkIfTokenIsValid, logout } from 'helpers/authentication'
import { getActivePage } from 'helpers/route'

// Route: Protected
function Protected () {
	// Data
	useToken()
	useAccount(true)
	const { account } = useContext(Data)
	const { willRedirect } = useRedirect({ willSkip: !account?.isLatestTermsOfServiceAccepted || getActivePage() === '2fa' })

	// Functions (Memoized)
	const logoutIfUnauthorized = useCallback(() => {
		if (document.visibilityState === 'visible') {
			if (!checkIfTokenIsValid()) logout()
		}
	}, [])

	// Effects
	useEffect(() => {
		document.addEventListener('visibilitychange', logoutIfUnauthorized)
		return () => document.removeEventListener('visibilitychange', logoutIfUnauthorized)
	}, [logoutIfUnauthorized])

	// Render
	if (willRedirect || typeof(account?.isLatestTermsOfServiceAccepted) !== 'boolean') return null
	return (
		<Routes>
			{/* Root (Fixed) */}
			<Route
				path="/"
				element={account.isLatestTermsOfServiceAccepted ? <Hub /> : <TermsOfService />} />
			{/* Account */}
			{/*
			<Route
				path="account/*"
				element={<Account />} />
			*/}
			{/* Password change */}
			<Route
				path="password-change"
				element={<PasswordChange />} />
			{/* Two-factor authentication */}
			<Route
				path="2fa"
				element={<TwoFactorAuthentication />} />
			{/* Login */}
			<Route
				path="login"
				element={<Navigate to="/" />} />
			{/* Register */}
			<Route
				path="register"
				element={<Navigate to="/" />} />
			{/* Reset */}
			<Route
				path="reset"
				element={<Navigate to="/" />} />
			{/* Verification */}
			<Route
				path="verification"
				element={<Navigate to="/" />} />
			{/* Fallback (Fixed) */}
			<Route
				path="*"
				element={<Error />} />
		</Routes>
	)
}

// Export
export default Protected
